import { render, staticRenderFns } from "./exam-footer.vue?vue&type=template&id=a355684a&scoped=true&"
import script from "./exam-footer.vue?vue&type=script&lang=js&"
export * from "./exam-footer.vue?vue&type=script&lang=js&"
import style0 from "./exam-footer.vue?vue&type=style&index=0&id=a355684a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a355684a",
  null
  
)

export default component.exports